import React from "react";
import { useState } from "react";
import SearchGames from "../../components/SearchGames";
import { Button } from "react-bootstrap";
import { AiOutlineSearch } from "react-icons/ai";
const SubCasino = ({
  header,
  subCasino,
  setSubCasino,
  casinoFilter,
  casinoFilterHandel,
}) => {
  const [showGameSearchList, setShowGameSearchList] = useState(false);

  const live = [
    {
      name: "EVOULUTION",
      image:
        "/assets/platformHeader/EG4-WHITE.webp",
    },
    {
      name: "PP",
      image:
        "/assets/platformHeader/PP-WHITE.webp",
    },
    {
      name: "SEXY",
      image:
        "/assets/platformHeader/SEX-WHITE.webp",
    },
    {
      name: "VIACASINO",
      image:
        "/assets/platformHeader/VIA-WHITE.webp",
    },
    {
      name: "PT",
      image:
        "/assets/platformHeader/PT-WHITE.webp",
    },
  ];
  const table = ["SPRIBE", "KINGMAKER", "JILI", "PG", "NETENT"];
  const slot = [
    {
      name: "PG",
      image:
        "/assets/platformHeader/PG-WHITE.webp",
    },
    {
      name: "PP",
      image:
        "/assets/platformHeader/PP-WHITE.webp",
    },
    {
      name: "JILI",
      image:
        "/assets/platformHeader/JL-WHITE.webp",
    },
    {
      name: "SPRIBE",
      image:
        "/assets/platformHeader/SPB-WHITE.webp",
    },
    {
      name: "FC",
      image:
        "/assets/platformHeader/FC-WHITE.webp",
    },
    {
      name: "JDB",
      image:
        "/assets/platformHeader/JDB-WHITE.webp",
    },
    {
      name: "RT",
      image:
        "/assets/platformHeader/RT-WHITE.webp",
    },
    {
      name: "BTG",
      image:
        "/assets/platformHeader/BTG-WHITE.webp",
    },
    {
      name: "FASTSPIN",
      image:
        "/assets/platformHeader/FS-WHITE.webp",
    },
    {
      name: "DRAGONSOFT",
      image: "/assets/platformHeader/dragoon.webp",
    },
    {
      name: "ILOVEU",
      image: "/assets/platformHeader/iloveu.webp",
    },
    {
      name: "NETENT",
      image: "/assets/platformHeader/netent.webp",
    },
    { name: "NLC", image: "/assets/platformHeader/nlc.webp" },
    { name: "PLAY8", image: "/assets/platformHeader/play8.webp" },
    { name: "PT", image: "/assets/platformHeader/PT-WHITE.webp" },
    {
      name: "SMARTSOFT",
      image: "/assets/platformHeader/smartsoft.webp",
    },
    { name: "YESBINGO", image: "/assets/platformHeader/yellow-bet.webp" },
    { name: "YL", image: "/assets/platformHeader/yellow.webp" },
    {
      name: "HACKSAW",
      image: "/assets/platformHeader/hacksaw.webp",
    },
    { name: "JOKER", image: "/assets/platformHeader/joker.webp" },
    {
      name: "LADYLUCK",
      image: "/assets/platformHeader/ladyluck.webp",
    },
    { name: "CG", image: "/assets/platformHeader/cg.webp" },
    { name: "KM", image: "/assets/platformHeader/km-logo.webp" },
    { name: "SPADE", image: "/assets/platformHeader/spade.webp" },
  ];
  const fishing = [
    {
      name: "JILI",
      image:
        "/assets/platformHeader/JL-WHITE.webp",
    },
    {
      name: "FC",
      image:
        "/assets/platformHeader/FC-WHITE.webp",
    },
    { name: "JOKER", image: "/assets/platformHeader/joker.webp" },
    { name: "SPADE", image: "/assets/platformHeader/spade.webp" },
    {
      name: "FASTSPIN",
      image:
        "/assets/platformHeader/FS-WHITE.webp",
    }, {
      name: "JDB",
      image:
        "/assets/platformHeader/JDB-WHITE.webp",
    },
  ];
  const arcade = ["JDB", "FC", "SPRIBE"];
  const lottery = ["KINGMAKER", "JILI", "JOKER", "YESBINGO", "SABA"];
  const crash = ["SPRIBE", "KINGMAKER", "JILI", "PP"];
  const esports = ["E1SPORT"];
  const poker = [
    {
      name: "JILI",
      image:
        "/assets/platformHeader/JL-WHITE.webp",
    },
    { name: "KM", image: "/assets/platformHeader/km-logo.webp" }
  ];
  const obj = {
    live: live,
    slot: slot,
    table: table,
    fishing: fishing,
    arcade: arcade,
    lottery: lottery,
    crash: crash,
    esports: esports,
    poker: poker,
  };

  return (
    <>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          padding: "10px",
          background: "#002632",
          border: "1.5px solid #006165",
          borderRadius: ".3rem",

          position: "sticky",
          top: "0px",
          zIndex: "9",
          margin: "10px",
        }}
        className="d-flex align-items-center"
      >
        <div
          style={{
            display: "flex",
            overflowX: "auto",
            gap: "10px",
            scrollbarWidth: "none",
          }}
        >
          {" "}
          <button
            onClick={() => setSubCasino("all")}
            className={`vendor-menu-item ${"all" == subCasino ? "active" : ""}`}
          >
            <span>All</span>
          </button>
          {obj[header].map((res) => {
            return (
              <button
                onClick={() => setSubCasino(res?.name)}
                className={`vendor-menu-item ${res?.name == subCasino ? "active" : ""}`}
              >
                <img
                  alt={res?.name}
                  class="object-contain"
                  style={{ minWidth: "56px", maxHeight: "28px" }}
                  src={res?.image}
                />
              </button>
            );
          })}
        </div>
      </div>

      {showGameSearchList && (
        <SearchGames setShowGameSearchList={setShowGameSearchList} />
      )}
    </>
  );
};

export default SubCasino;
